// ==============================================
// COUNTRY-BASED PRICING AND DELIVERY LOGIC
// ==============================================

let pricingMap = {
  SINGAPORE: { currency: "SG$", price: 129, gift_price: 179, cost: 6.3 },
  "UNITED ARAB EMIRATES": { currency: "AED", price: 369, gift_price: 509, cost: 17.5 },
  "UNITED KINGDOM": { currency: "£", price: 79, gift_price: 99, cost: 4.0 },
  "NEW ZEALAND": { currency: "NZ$", price: 179, gift_price: 239, cost: 5.95 },
  CANADA: { currency: "CA$", price: 139, gift_price: 189, cost: 5.95 },
  AUSTRALIA: { currency: "$", price: 99, gift_price: 139, cost: 4.95 },
  "UNITED STATES": { currency: "$", price: 99, gift_price: 139, cost: 4.95 },
  AUSTRIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  ITALY: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  BELGIUM: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  ESTONIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  GERMANY: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  FINLAND: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  FRANCE: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  GREECE: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  CROATIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  IRELAND: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  LITHUANIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  LUXEMBOURG: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  LATVIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  MONACO: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  MONTENEGRO: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  MALTA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  KOSOVO: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  SPAIN: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  NETHERLANDS: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  PORTUGAL: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  SLOVENIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  SLOVAKIA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  "SAN MARINO": { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  "VATICAN CITY": { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  ANDORRA: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  CYPRUS: { currency: "€", price: 89, gift_price: 119, cost: 4.25 },
  REST: { currency: "$", price: 99, gift_price: 139, cost: 4.95 },
};

let conversionRateMap = {
  SINGAPORE: { currency: "SG$", rate: 1.35 },
  "UNITED ARAB EMIRATES": { currency: "AED", rate: 3.8 },
  "UNITED KINGDOM": { currency: "£", rate: 0.79 },
  "NEW ZEALAND": { currency: "NZ$", rate: 1.81 },
  CANADA: { currency: "CA$", rate: 1.45 },
  AUSTRALIA: { currency: "$", rate: 1 },
  CYPRUS: { currency: "€", rate: 0.95 },
  ESTONIA: { currency: "€", rate: 0.95 },
  FINLAND: { currency: "€", rate: 0.95 },
  FRANCE: { currency: "€", rate: 0.95 },
  GERMANY: { currency: "€", rate: 0.95 },
  IRELAND: { currency: "€", rate: 0.95 },
  ITALY: { currency: "€", rate: 0.95 },
  LATVIA: { currency: "€", rate: 0.95 },
  LITHUANIA: { currency: "€", rate: 0.95 },
  LUXEMBOURG: { currency: "€", rate: 0.95 },
  MALTA: { currency: "€", rate: 0.95 },
  NETHERLANDS: { currency: "€", rate: 0.95 },
  PORTUGAL: { currency: "€", rate: 0.95 },
  "SAN MARINO": { currency: "€", rate: 0.95 },
  SLOVAKIA: { currency: "€", rate: 0.95 },
  SLOVENIA: { currency: "€", rate: 0.95 },
  SPAIN: { currency: "€", rate: 0.95 },
  "VATICAN CITY": { currency: "€", rate: 0.95 },
  REST: { currency: "$", rate: 1 },
};

const monthNames = ["Jan.", "Feb.", "Mar.", "Apr.", "May.", "Jun.", "Jul.", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];

const europeanCountries = [
  "Albania", "Andorra", "Austria", "Belarus", "Belgium", "Bosnia and Herzegovina", "Bulgaria", "Croatia", "Cyprus",
  "Czech Republic", "Denmark", "Estonia", "Finland", "France", "Germany", "Greece", "Hungary", "Iceland", "Ireland",
  "Italy", "Kosovo", "Latvia", "Liechtenstein", "Lithuania", "Luxembourg", "Malta", "Moldova", "Monaco", "Montenegro",
  "Netherlands", "North Macedonia", "Norway", "Poland", "Portugal", "Romania", "Russia", "San Marino", "Serbia",
  "Slovakia", "Slovenia", "Spain", "Sweden", "Switzerland", "Ukraine", "Vatican City"
];

const unitedKingdom = ["United Kingdom"];
const us = ["United States", "Canada"];
const aus = ["Australia", "New Zealand"];
const countriesForPriceElements = { CANADA: "CA", "NEW ZEALAND": "NZ" };

// ===============================
// PERFORMANCE UTILITIES
// ===============================

// Cache for formatted numbers to avoid repeated string operations
const formattedNumberCache = new Map();

// Throttle function to limit execution frequency
function throttle(func, limit) {
  let inThrottle;
  return function(...args) {
    if (!inThrottle) {
      func.apply(this, args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

// Debounce function for operations that should only run after activity stops
function debounce(func, wait) {
  let timeout;
  return function(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Country data promise cache - fetch only once
let countryDataPromise = null;
function getCountryData() {
  if (!countryDataPromise) {
    countryDataPromise = fetch("https://robify.ezapp.ovh/country?justcountry=1", {
      // Add timeout and proper error handling
      signal: AbortSignal.timeout(5000) // 5 second timeout
    })
      .then(res => {
        if (!res.ok) throw new Error('Network response was not ok');
        return res.text();
      })
      .catch(error => {
        console.warn("Country fetch failed, using default:", error);
        return "REST"; // Fallback to REST pricing
      });
  }
  return countryDataPromise;
}

// ===============================
// DATE AND DELIVERY FUNCTIONS
// ===============================

function isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6;
}

function addWorkingDays(startDate, numWorkingDays) {
  let resultDate = new Date(startDate);
  while (numWorkingDays > 0) {
    resultDate.setDate(resultDate.getDate() + 1);
    if (!isWeekend(resultDate)) numWorkingDays--;
  }
  return resultDate;
}

function calculateDeliveryDates(countryName) {
  let startOffset = 0;
  let endOffset = 0;

  if (europeanCountries.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 5; endOffset = 11;
  } else if (unitedKingdom.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 3; endOffset = 9;
  } else if (us.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 3; endOffset = 9;
  } else if (aus.some(c => c.toLowerCase() === countryName.toLowerCase())) {
    startOffset = 3; endOffset = 7;
  } else {
    startOffset = 6; endOffset = 13;
  }

  const startDate = new Date();

  const sinceDateFastest = addWorkingDays(startDate, startOffset - 2);
  const beforeDateFastest = addWorkingDays(startDate, endOffset - 2);

  const formatDate = (date, country) => {
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return (country === "United States" || country === "Canada")
      ? `${month} ${day} ${year}`
      : `${day} ${month} ${year}`;
  };

  const formattedDate = `${formatDate(sinceDateFastest, countryName)} - ${formatDate(beforeDateFastest, countryName)}`;
  
  // Use DocumentFragment for better performance when updating multiple elements
  const deliveryDateElements = document.getElementsByClassName("delivery_date");
  for (let i = 0; i < deliveryDateElements.length; i++) {
    deliveryDateElements[i].textContent = formattedDate;
  }
}

function extractAmount(str) {
  // Keep only digits, commas, dots, and minus signs
  let cleaned = str.replace(/[^\d.,-]/g, '').trim();

  // Remove leading dots or commas before any digits
  cleaned = cleaned.replace(/^[.,]+/, '');

  // Detect which symbol is the decimal separator
  const lastComma = cleaned.lastIndexOf(',');
  const lastDot = cleaned.lastIndexOf('.');

  let decimalSeparator = null;

  if (lastComma > -1 && lastDot > -1) {
    // Both exist → whichever comes later is likely the decimal separator
    decimalSeparator = lastComma > lastDot ? ',' : '.';
  } else if (lastComma > -1) {
    decimalSeparator = ',';
  } else if (lastDot > -1) {
    decimalSeparator = '.';
  }

  // Remove thousand separators and normalize to standard dot-decimal
  let normalized = cleaned;
  if (decimalSeparator === ',') {
    // European style: 1.234,56 → 1234.56
    normalized = normalized.replace(/\./g, '').replace(',', '.');
  } else if (decimalSeparator === '.') {
    // US style: 1,234.56 → 1234.56
    normalized = normalized.replace(/,/g, '');
  }

  // Convert to number
  const amount = parseFloat(normalized);

  // Return NaN if not a valid number
  return isNaN(amount) ? NaN : amount;
}

function convertAmount(originalAmount, conversionRate) {
  return Math.ceil(originalAmount * conversionRate).toFixed(0);
}

// ===============================
// OPTIMIZED PRICING UPDATE
// ===============================

function updatePricingElements(country) {
  try {
    let processed = country.split(", ")[0].split(" (")[0];
    const pricing = pricingMap[processed.toUpperCase()] || pricingMap.REST;

    // Batch DOM reads and writes separately for better performance
    const freeShippingPrices = document.getElementsByClassName("free_shipping_price");
    const freeGiftPrices = document.getElementsByClassName("free_gift_price");
    const freeShippingCosts = document.getElementsByClassName("free_shipping_cost");
    const deliveryCountries = document.getElementsByClassName("delivery_country");
    const priceElements = document.getElementsByClassName("price-australia");
    const convertiblePrices = document.getElementsByClassName("currency_convertible");
    const freeShippingUnlockData = document.getElementsByClassName("free_shipping_unlock_data");
    const freeGiftUnlockData = document.getElementsByClassName("free_gift_unlock_data");

    // Update pricing elements
    const priceText = `${pricing.currency}${pricing.price}`;
    for (let i = 0; i < freeShippingPrices.length; i++) {
      freeShippingPrices[i].innerText = priceText;
    }

    const giftPriceText = `${pricing.currency}${pricing.gift_price}`;
    for (let i = 0; i < freeGiftPrices.length; i++) {
      freeGiftPrices[i].innerText = giftPriceText;
    }

    const costText = `${pricing.currency}${pricing.cost}`;
    for (let i = 0; i < freeShippingCosts.length; i++) {
      freeShippingCosts[i].innerText = costText;
    }

    for (let i = 0; i < deliveryCountries.length; i++) {
      deliveryCountries[i].innerText = processed;
    }

    const countryUpper = processed.trim().toUpperCase();
    if (countriesForPriceElements[countryUpper]) {
      const countryCode = countriesForPriceElements[countryUpper];
      for (let i = 0; i < priceElements.length; i++) {
        priceElements[i].textContent = countryCode;
      }
    }

    // Handle convertible prices
    const converted = conversionRateMap[processed] || conversionRateMap["REST"];
    for (let i = 0; i < convertiblePrices.length; i++) {
      const element = convertiblePrices[i];
      const amountToConvert = extractAmount(element.innerHTML);
      let preDefinedPrice = element.getAttribute("data-price");
      if (preDefinedPrice) {
        preDefinedPrice = preDefinedPrice / 100;
      }
      
      if (element.getAttribute("data-convert") === "false") {
        element.innerHTML = converted.currency + (preDefinedPrice ?? amountToConvert);
      } else {
        element.innerHTML = converted.currency + convertAmount(preDefinedPrice ?? amountToConvert, converted.rate);
      }
    }

    for (let i = 0; i < freeShippingUnlockData.length; i++) {
      const element = freeShippingUnlockData[i];
      element.dataset.unlockThreshold = pricing.price * 100;
    }

    for (let i = 0; i < freeGiftUnlockData.length; i++) {
      const element = freeGiftUnlockData[i];
      element.dataset.unlockThreshold = pricing.gift_price * 100;
    }

    if (freeShippingUnlockData.length > 0) {
      document.dispatchEvent(new Event('freeShippingGiftData:updated'));
    }

    calculateDeliveryDates(processed.toLowerCase());
  } catch (e) {
    console.error("Unable to update free shipping pricing:", e);
  }
}

// Initialize pricing on page load - non-blocking
document.addEventListener("DOMContentLoaded", function () {
  const freeShippingPrices = document.getElementsByClassName("free_shipping_price");
  const freeGiftPrices = document.getElementsByClassName("free_gift_price");
  const freeShippingCosts = document.getElementsByClassName("free_shipping_cost");
  const deliveryCountries = document.getElementsByClassName("delivery_country");
  const priceElements = document.getElementsByClassName("price-australia");
  const convertiblePrices = document.getElementsByClassName("currency_convertible");

  // Only fetch if we have elements that need updating
  if (freeShippingPrices.length || freeGiftPrices.length || freeShippingCosts.length || 
      deliveryCountries.length || priceElements.length || convertiblePrices.length) {
    
    // Non-blocking async fetch
    getCountryData().then(country => {
      updatePricingElements(country);
    });
  }
});

// ===============================
// CART PAGE SCRIPTS - OPTIMIZED
// ===============================

$(document).ready(function () {
  // Utility: Add commas to numbers with caching
  function numberWithCommas(number) {
    const key = number.toString();
    
    // Check cache first
    if (formattedNumberCache.has(key)) {
      return formattedNumberCache.get(key);
    }
    
    const parts = key.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    const result = parts.join(".");
    
    // Cache the result
    formattedNumberCache.set(key, result);
    
    // Limit cache size to prevent memory issues
    if (formattedNumberCache.size > 100) {
      const firstKey = formattedNumberCache.keys().next().value;
      formattedNumberCache.delete(firstKey);
    }
    
    return result;
  }

  // ===============================
  // Check All Cart Items - Optimized
  // ===============================
  $(document).on("change", "#ckbCheckAll", function () {
    const $cartTotal = $(".cart-page-subtotal").children().find(".money");
    const totalAttr = $(".cart-page-subtotal").attr("data-maintotal-price");
    const isChecked = $(this).is(":checked");

    if (isChecked) {
      $(".custom-cart-note").hide();

      // Batch DOM operations
      const $checkboxes = $(".checkBoxClass");
      const overviewItems = [];
      let currency = "";

      $checkboxes.each(function () {
        const $this = $(this);
        $this.prop("checked", true);

        const parent = $this.closest(".cart__item");
        const productTitle = parent.find(".cart__item--title").text();
        const productQty = parent.find(".quantity").val();
        currency = parent.find(".modal_price .money").attr("data-currency");
        const price = parseFloat(parent.find(".modal_price .money.mainprice").attr("data-money"));
        const productId = $this.val();
        const totalPrice = price * productQty;

        overviewItems.push({
          id: productId,
          title: productTitle,
          qty: productQty,
          price: totalPrice,
          currency: currency
        });
      });

      // Update overview in one operation
      const $cartsubtotalitem = $(".cartsubtotalitem");
      overviewItems.forEach(item => {
        const $existing = $(`.overview-product[data-id="${item.id}"]`);
        
        if (!$existing.length) {
          const html = `
            <li class="overview-product" data-id="${item.id}">
              <div class="overview-product-box">
                <span class="overview-product-qty">${item.qty} X</span>
                <span class="overview-product-title">${item.title}</span>
              </div>
              <div class="overvie-title">
                <span class="overview-product-price" data-price="${item.price}">
                  ${item.currency}${numberWithCommas(item.price.toFixed(2))}
                </span>
              </div>
            </li>`;
          $cartsubtotalitem.append(html);
        } else {
          $existing.find(".overview-product-title").text(item.title);
          $existing.find(".overview-product-qty").text(`${item.qty} X`);
          $existing.find(".overview-product-price")
            .text(`${item.currency}${numberWithCommas(item.price.toFixed(2))}`)
            .attr("data-price", item.price);
        }
      });

      if (currency) {
        $cartTotal.text(`${currency}${numberWithCommas(parseFloat(totalAttr).toFixed(2))}`);
        $cartTotal.attr("data-total-price", numberWithCommas(parseFloat(totalAttr).toFixed(2)));
      }
    } else {
      // Batch remove operations
      const $checkboxes = $(".checkBoxClass");
      const productIds = [];
      
      $checkboxes.each(function () {
        const $this = $(this);
        productIds.push($this.val());
        $this.prop("checked", false);
      });
      
      productIds.forEach(id => {
        $(`.overview-product[data-id="${id}"]`).remove();
      });
    }
  });

  // ===============================
  // Individual Cart Item Checkbox - Optimized
  // ===============================
  $(document).on("change", ".cart__item .checkBoxClass", function () {
    const $this = $(this);
    const parent = $this.closest(".cart__item");
    const productTitle = parent.find(".cart__item--title").text();
    const productQty = parent.find(".quantity").val();
    const currency = parent.find(".modal_price .money").attr("data-currency");
    const price = parseFloat(parent.find(".modal_price .money.mainprice").attr("data-money"));
    const productId = $this.val();
    const totalPrice = price * productQty;
    const $cartTotal = $(".cart-page-subtotal").children().find(".money");
    const isChecked = $this.is(":checked");

    if (isChecked) {
      $(".custom-cart-note").hide();
      $(".overview-product").css("display", "flex");

      const $existing = $(`.overview-product[data-id="${productId}"]`);
      
      if (!$existing.length) {
        const html = `
          <li class="overview-product" data-id="${productId}" style="display:flex;">
            <div class="overview-product-box">
              <span class="overview-product-qty">${productQty} X</span>
              <span class="overview-product-title">${productTitle}</span>
            </div>
            <div class="overvie-title">
              <span class="overview-product-price" data-price="${totalPrice}">
                ${currency}${numberWithCommas(totalPrice.toFixed(2))}
              </span>
            </div>
          </li>`;
        $(".cartsubtotalitem").append(html);
      } else {
        $existing.find(".overview-product-title").text(productTitle);
        $existing.find(".overview-product-qty").text(`${productQty} X`);
        $existing.find(".overview-product-price")
          .text(`${currency}${numberWithCommas(totalPrice.toFixed(2))}`)
          .attr("data-price", totalPrice);
      }
    } else {
      $(`.overview-product[data-id="${productId}"]`).remove();
      $("#ckbCheckAll").prop("checked", false);
    }

    // Calculate Total - optimized
    let total = 0;
    $(".cart__item .checkBoxClass:checked").each(function () {
      const itemPrice = parseFloat($(this).closest(".cart__item").find(".price_total .money").attr("data-money"));
      total += itemPrice;
    });

    $cartTotal.text(`${currency}${numberWithCommas(total.toFixed(2))}`);
    $cartTotal.attr("data-total-price", numberWithCommas(total.toFixed(2)));
  });

  // ===============================
  // Custom Checkout Button
  // ===============================
  $(".customcheckout").click(function () {
    const uncheckedCount = $("input.checkBoxClass:checkbox:not(:checked)").length;
    const totalItems = $(".cart__item").length;

    if ($(".ckbCheckAll").prop("checked")) {
      $("#checkout").trigger("click");
      return;
    }

    const lineItems = [];
    $(".cart__item").each(function () {
      const $checkbox = $(this).find(".checkBoxClass");
      const id = $checkbox.attr("data-id-key");
      if (!$checkbox.is(":checked")) lineItems.push(id);
    });

    const data = { updates: {} };
    lineItems.forEach(id => (data.updates[id] = 0));

    if (totalItems === uncheckedCount) {
      $(".custom-cart-note").show();
    } else {
      $(".custom-cart-note").hide();
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data,
        dataType: "json",
        success() {
          $("#checkout").trigger("click");
        },
        error(xhr, status, error) {
          console.error("Cart update failed:", error);
          // Still proceed to checkout even if update fails
          $("#checkout").trigger("click");
        }
      });
    }
  });

  // ===============================
  // Discount Code Auto Checkout
  // ===============================
  $(".discount-button").click(function () {
    if ($(".discount-code input").val().length > 0) {
      $(".customcheckout").trigger("click");
    }
  });

  // ===============================
  // Prevent Manual Quantity Edit
  // ===============================
  $(".product-quantity-block .quantity").keydown(() => false);

  // ===============================
  // Scroll to Main Add to Cart
  // ===============================
  $(".extra-add-to-cart .add_to_cart").on("click", function (event) {
    event.preventDefault();
    const target = $(this).attr("data-href");
    const $target = $(target);
    if ($target.length) {
      $("html, body").animate(
        { scrollTop: $target.offset().top - 150 },
        1000
      );
    }
  });

  // ===============================
  // Add iframe Classes to Parent
  // ===============================
  $(".product_banner iframe").each(function () {
    const className = $(this).attr("class");
    if (className) {
      $(this).closest("div").addClass(className);
    }
  });

  $(".gift-code-box").click(function () {
    // Placeholder for gift code interaction
  });
});

// ===============================
// WINDOW SCROLL / RESIZE LOGIC - OPTIMIZED
// ===============================

function isFullyInViewport($el) {
  if (!$el.length) return false;
  
  const elementTop = $el.offset().top;
  const elementBottom = elementTop + $el.outerHeight();
  const viewportTop = $(window).scrollTop();
  const viewportBottom = viewportTop + $(window).height();

  return (
    elementTop >= viewportTop &&
    elementBottom <= viewportBottom &&
    elementTop <= viewportBottom &&
    elementBottom >= viewportTop
  );
}

// Extra ATC visibility toggle on product pages - THROTTLED
const handleProductPageScroll = throttle(function () {
  if (!$("body.custom-productpage").length) return;
  
  const $productForm = $(".shopify-product-form");
  if (!$productForm.length) return;
  
  const div = $productForm.position();
  if (div) {
    const scrollTo = div.top + $productForm.height();
    const $extraATC = $(".extra-add-to-cart");
    
    if ($(window).scrollTop() > scrollTo) {
      $extraATC.removeClass("hidden");
    } else {
      $extraATC.addClass("hidden");
    }
  }
}, 100); // Run max once per 100ms

// Sticky checkout button behavior on cart pages - THROTTLED
const handleCartPageScroll = throttle(function () {
  if (!$("body.custom-cartpage").length) return;
  
  const $continueShopping = $(".continue-shopping");
  if (!$continueShopping.length) return;
  
  const div = $continueShopping.position();
  if (div) {
    const scrollTo = div.top + $continueShopping.height();
    const $checkoutBtn = $(".tos_warning.checkout_button");

    if ($(window).scrollTop() > scrollTo) {
      $checkoutBtn.removeClass("non-sticky").addClass("chk-sticky");
    } else {
      $checkoutBtn.addClass("non-sticky").removeClass("chk-sticky");
    }
  }
}, 100); // Run max once per 100ms

// Combined scroll handler
$(window).on("scroll", function() {
  handleProductPageScroll();
  handleCartPageScroll();
});

// Debounced resize handler
$(window).on("resize", debounce(function() {
  handleProductPageScroll();
  handleCartPageScroll();
}, 150));

// ===============================
// CHRISTMAS DELIVERY GUARANTEE
// ===============================

function guaranteed(its, first = false) {
  const lfc_container = document.getElementById('lfc_container');
  if (!lfc_container) {
    return;
  }
  
  if (its) {
    const msgtoset = '🎁 <b>Guaranteed</b> Christmas Delivery!';
    if (lfc_container.innerHTML !== msgtoset) {
      lfc_container.innerHTML = msgtoset;
      lfc_container.style.display = 'block';
    }
  } else {
    const msgtoset = 'Christmas delivery not guaranteed';
    if (first) {
      lfc_container.innerHTML = '';
      lfc_container.style.display = 'none';
      return;
    }

    if (lfc_container.innerHTML !== msgtoset) {
      lfc_container.innerHTML = msgtoset;
      lfc_container.style.display = 'block';
    }
  }
}

function getFormattedDate() {
  const options = { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' };
  const londonDate = new Date().toLocaleDateString('en-GB', options);

  // The result from toLocaleDateString will be in the format dd/mm/yyyy
  // We need to split it and rearrange to yyyy-mm-dd
  const [day, month, year] = londonDate.split('/');
  return `${year}-${month}-${day}`;
}

function LFCfindGetParameter(parameterName) {
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split('&')
    .forEach(function (item) {
      tmp = item.split('=');
      if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
    });
  return result;
}

function getLFCVID() {
  var vid = LFCfindGetParameter('variant');
  if (vid === null && window.lfcProduct && window.lfcProduct.variants) {
    vid = window.lfcProduct.variants[0].id;
  }
  return vid;
}

var deliveryGuaranteedCountries = ['UNITED STATES'];

function checkDESTwenty(changedVariant = false) {
  var vid = getLFCVID();
  if (!vid) return;

  var firstSKU = false;
  
  if (!window.lfcProduct || !window.lfcProduct.variants) {
    return;
  }
  
  for (let i = 0; i < window.lfcProduct.variants.length; i++) {
    if (window.lfcProduct.variants[i].id == vid) {
      var targetVariantId = window.lfcProduct.variants[i].id;
      if (i == 0 && !changedVariant) {
        // firstSKU = true; // hide box on landing
      }
      if (typeof variantQuantities !== 'undefined') {
        if (variantQuantities[targetVariantId] && variantQuantities[targetVariantId] > 1) {
          // The variant exists in the array and has a value greater than 0
          guaranteed(true);
          return;
        }
      }
      guaranteed(false, firstSKU);
      return;
    }
  }
}

function checkDeliveryGuarantee() {
  if (!window.actualcountry) return;
  
  if (deliveryGuaranteedCountries.includes(window.actualcountry.trim())) {
    const options = document.getElementsByClassName('selectedoption');
    for (let j = 0; j < options.length; j++) {
      options[j].addEventListener('change', function () {
        setTimeout(function () {
          checkDESTwenty(true);
        }, 100);
      });
    }

    checkDESTwenty();
  } else {
    guaranteed(false);
  }
}

// Initialize delivery guarantee check - optimized with date check
const currentDate = getFormattedDate();
if (currentDate >= '2026-12-16') {
  if (currentDate >= '2026-12-23') {
    if (currentDate <= '2026-12-25') {
      guaranteed(false);
    }
  } else {
    guaranteed(false, true);
    
    // Use the cached country data promise
    getCountryData()
      .then((country) => {
        window.actualcountry = country;
        checkDeliveryGuarantee();
      })
      .catch((error) => {
        console.error('Error during country fetch for delivery guarantee: ' + error.message);
        guaranteed(false, true);
      });
  }
}

// Handle show only during Christmas Elements
document.addEventListener('DOMContentLoaded', function () {
  var christmasElements = document.querySelectorAll('.christmas-only');

  if (currentDate >= '2026-12-16' && currentDate <= '2026-12-25') {
    christmasElements.forEach(function (el) {
      el.style.display = 'block';
    });
  } else {
    christmasElements.forEach(function (el) {
      el.style.display = 'none';
    });
  }
});

// ===============================
// GIFT BAG LISTENER - OPTIMIZED
// ===============================

function attachGiftBagListener() {
  const giftBagCheckbox = document.getElementById('giftBag');
  if (giftBagCheckbox) {
    // Avoid attaching multiple listeners
    if (giftBagCheckbox.dataset.listenerAttached) {
      return true;
    }
    
    const options = document.getElementsByClassName('selectedoption');
    for (let j = 0; j < options.length; j++) {
      options[j].addEventListener('change', function () {
        const giftBag = document.getElementById('giftBag');
        if (giftBag) giftBag.checked = false;
      });
    }
    
    giftBagCheckbox.addEventListener('change', function () {
      if (this.checked) {
        giftBagChecked();
      } else {
        giftBagUnchecked();
      }
    });
    
    giftBagCheckbox.dataset.listenerAttached = 'true';
    return true;
  }
  return false;
}

function initGiftBagObserver() {
  // If it's already on the page, just attach and do nothing else.
  if (attachGiftBagListener()) {
    return;
  }

  // Use more specific target if possible to reduce observer overhead
  const targetNode = document.querySelector('.product-form-container') || document.body;
  
  const observer = new MutationObserver((mutationsList, observer) => {
    // Each time there's a change, check if giftBag now exists
    if (attachGiftBagListener()) {
      observer.disconnect();
    }
  });

  // Start observing for newly added elements
  observer.observe(targetNode, { childList: true, subtree: true });
}

function giftBagChecked() {
  guaranteed(true);
}

function giftBagUnchecked() {
  checkDeliveryGuarantee();
}

// Initialize once the DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initGiftBagObserver);
} else {
  initGiftBagObserver();
}

// ===============================
// KLAVIYO PRIVACY POLICY LINK - OPTIMIZED
// ===============================

function replacePrivacyPolicyWithLink() {
  // Ensure the form exists
  const klaviyoForm = document.querySelector('div.klaviyo-form');

  if (klaviyoForm) {
    // Check if the form already has been processed (avoid multiple runs)
    if (klaviyoForm.hasAttribute('data-processed')) {
      return true;  // Return true to stop checking
    }

    // Find elements that contain the privacy policy text
    const elementsContainingPrivacyPolicy = Array.from(klaviyoForm.querySelectorAll('label')).filter(function(el) {
      return el.textContent.includes('I have read and accept privacy policy');
    });

    if (elementsContainingPrivacyPolicy.length > 0) {
      elementsContainingPrivacyPolicy[0].innerHTML = elementsContainingPrivacyPolicy[0].innerHTML.replace(
        /\>I have read and accept privacy policy/,
        '>I have read and accept&nbsp;<a href="https://www.thelittlelearnerstoys.com/policies/privacy-policy" style="color: #FFFFFF; text-decoration: underline;" target="_blank">privacy policy</a>'
      );

      // Mark the form as processed to prevent multiple executions
      klaviyoForm.setAttribute('data-processed', 'true');
      return true;  // Return true to stop checking
    }
  }
  return false;  // Return false to continue checking
}

// Optimized approach: Use requestIdleCallback if available, with fallback
function initPrivacyPolicyReplacer() {
  let attempts = 0;
  const maxAttempts = 10;
  
  function tryReplace() {
    if (replacePrivacyPolicyWithLink() || attempts >= maxAttempts) {
      return; // Stop if successful or max attempts reached
    }
    
    attempts++;
    
    // Use requestIdleCallback for better performance, with setTimeout fallback
    if ('requestIdleCallback' in window) {
      requestIdleCallback(tryReplace, { timeout: 500 });
    } else {
      setTimeout(tryReplace, 500);
    }
  }
  
  // Start checking after initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(tryReplace, 1000);
    });
  } else {
    setTimeout(tryReplace, 1000);
  }
}

// Initialize
initPrivacyPolicyReplacer();

function initiateCountdownTimer() {
  const marginWindow = 30;
  const dayAnchorHour = 11; 
  const dayAnchorMinute = 0;
  const nightAnchorHour = 24;
  const nightAnchorMinute = 0;

  // Check if current time is within margin window of any anchor (10 AM, 10 PM)
  function isWithinLimitedWindow(now) {
    const anchors = [];

    // Check yesterday, today, and tomorrow to be safe across boundaries
    for (let offset = -1; offset <= 1; offset++) {
      const base = new Date(now);
      base.setDate(base.getDate() + offset);

      const tenAM = new Date(base);
      tenAM.setHours(dayAnchorHour, dayAnchorMinute, 0, 0);
      anchors.push(tenAM);

      const tenPM = new Date(base);
      tenPM.setHours(nightAnchorHour, nightAnchorMinute, 0, 0);
      anchors.push(tenPM);
    }

    return anchors.some(anchor => {
      const diff = Math.abs(now - anchor);
      return diff < marginWindow * 60 * 1000; // within margin window
    });
  }

  // Return the next anchor time (after the margin window)
  function getNextAnchorTime(now) {
    const anchors = [];

    const base = new Date(now);
    for (let offset = 0; offset <= 1; offset++) {
      const day = new Date(base);
      day.setDate(day.getDate() + offset);

      const tenAM = new Date(day);
      tenAM.setHours(dayAnchorHour, dayAnchorMinute, 0, 0);
      anchors.push(tenAM);

      const tenPM = new Date(day);
      tenPM.setHours(nightAnchorHour, nightAnchorMinute, 0, 0);
      anchors.push(tenPM);
    }

    return anchors.find(anchor => {
      const diff = anchor - now;
      return diff > marginWindow * 60 * 1000; // at least margin window away
    });
  }

  function updateCountdown() {
    const countdownElements = document.querySelectorAll('.countdown_timer');

    countdownElements.forEach(countdownElement => {
      const now = new Date();
  
      if (isWithinLimitedWindow(now)) {
        countdownElement.innerText = `LIMITED TIME ONLY`;
        return;
      }
  
      const target = getNextAnchorTime(now);
      if (!target) {
        countdownElement.textContent = "LIMITED TIME ONLY";
        return;
      }
  
      const diff = target - now;
  
      const hours = String(Math.floor(diff / 1000 / 60 / 60)).padStart(2, "0");
      const minutes = String(Math.floor((diff / 1000 / 60) % 60)).padStart(2, "0");
      const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");
  
      countdownElement.innerText = `${hours}:${minutes}:${seconds}`;
    });
  }

  updateCountdown();
  setInterval(updateCountdown, 1000);
}

document.addEventListener("DOMContentLoaded", initiateCountdownTimer);